import { InternLink } from '../intern/link';
import { InternServiceLink } from '../intern/service-link';

/**
 * Model definition for Sparkasse Assignment Form
 */
export interface FormsSparkasseAssignmentForm {
  __component: 'forms.sparkasse-assignment-form';
  assignmentHeadline?: string;
  assignmentSubline?: string;
  id: number;
  initalButton?: InternLink;
  initialHeadline: string;
  initialLinks: Array<InternServiceLink>;
  initialSubline: string;
  resultHeadline: string;
}

export function isFormsSparkasseAssignmentForm(obj: { __component?: string }): obj is FormsSparkasseAssignmentForm {
  return obj.__component === 'forms.sparkasse-assignment-form';
}
